import type { EmergencyCall } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCalls.types';
import { getMostRecentLoc } from '@rsos/utils/getMostRecentLoc';
import { formatAddressFromObject } from '../../../../AirAmbulanceForm/AirAmbulanceForm/utils';

interface MostRecentLocation {
  latitude: number;
  longitude: number;
  addressObject?: Record<string, string | undefined>;
  rgAddress?: string;
}

export interface CallLocation {
  latitude: number;
  longitude: number;
  address: string;
}

function digitsOf(value: string): string {
  return value.replace(/\D/g, '');
}

/**
 * Whether a caller ID matches a partially typed phone number. Numbers are
 * compared on digits only, so punctuation typed in either format (e.g.
 * `(608) 555-` or `608.555`) still narrows to the right calls.
 */
export function callerIdMatchesInput(callerId: string, input: string): boolean {
  const typedDigits = digitsOf(input);
  if (!typedDigits) {
    return true;
  }
  return digitsOf(callerId).includes(typedDigits);
}

/**
 * Most recent location of a call, with its address formatted for the form.
 * Returns null when the call has no usable location.
 */
export function getCallLocation(
  call: EmergencyCall | null | undefined,
): CallLocation | null {
  if (!call) {
    return null;
  }
  const latestLocation = getMostRecentLoc(call) as MostRecentLocation | null;
  if (!latestLocation) {
    return null;
  }

  return {
    latitude: latestLocation.latitude,
    longitude: latestLocation.longitude,
    address: latestLocation.addressObject
      ? formatAddressFromObject(latestLocation.addressObject)
      : (latestLocation.rgAddress ?? ''),
  };
}
